const local = 'LOCAL';
const dev = 'DEV';

const config = {
  env: process.env.REACT_APP_ENV,
  environments: {
    local,
    dev,
    uat: 'UAT',
    prod: 'PROD',
  },

  client_id: 'PXQf6LMyGxcF3efkqCOJ1EO1wfSfqzR6',
  domain: 'dev-sitk24ss2iowl228.eu.auth0.com',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};

export default config;
